import styled from "@emotion/styled";
import {
  Drawer,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

import { BackgroundGradient } from "@/components/shared/BackgroundGradient/component";

export const StyledText = styled(Text)`
  padding: 0px 32px;
  margin-bottom: 24px;
  max-width: 350px;
`;

export const StyledBlock = styled("div", {
  shouldForwardProp: (prop) => prop !== "isRow",
})<{ isRow?: boolean }>`
  margin-bottom: 28px;
  ${({ isRow }) =>
    isRow &&
    `
  display: flex;
  gap: 20px;
  width: 100%;

  & > div {
  width: 100%;
  }
`}
`;

export const StyledContainer = styled.div`
  padding: 42px 0;
`;

export const StyledDrawer = styled(Drawer)`
  width: 100%;
  max-width: 550px;
  align-items: center;
`;

export const StyledActions = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: center;
`;

export const StyledFormContainer = styled(BackgroundGradient)`
  padding: 40px;
`;
